class BuyNowButton extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;
    this.initiallyDisabled = this.button.disabled;
    this.button.addEventListener('click', this.handleClick.bind(this));
    // Al volver desde el checkout con "atrás", el navegador restaura la página desde su caché
    // con el botón todavía en estado "cargando": se reactiva para poder comprar de nuevo.
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      this.loading = false;
      this.button.disabled = this.initiallyDisabled;
    });
  }

  /** @param {MouseEvent} event */
  async handleClick(event) {
    event.preventDefault();

    if (this.button.disabled || this.loading) return;

    const formId = this.dataset.formId;
    const form = formId ? document.getElementById(formId) : null;
    if (!form) return;

    const formData = new FormData(form);
    const variantId = formData.get('id');

    if (!variantId) return;

    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match) properties[match[1]] = value;
    }

    const quantity = Number(formData.get('quantity')) || 1;
    const item = { id: variantId, quantity };
    if (Object.keys(properties).length) item.properties = properties;

    this.loading = true;
    this.button.disabled = true;

    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';

    try {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [item] }),
      });

      if (!response.ok) {
        this.loading = false;
        this.button.disabled = false;
        return;
      }

      window.location.href = `${root}checkout`;
    } catch (error) {
      this.loading = false;
      this.button.disabled = false;
    }
  }
}

customElements.define('buy-now-button', BuyNowButton);
